import { AppDispatch } from "redux/store";
import { CallLambda } from "./CallLambda";
import { setJobs, setJobIndex } from "redux/slices/user";
import Job from "redux/classes/Job";
import Session from "redux/classes/Session";

/**
 * Full refresh of the jobs table. Used on Home page mount, Run page
 * post-submit, and on RunNLI/RunDash unmount when the job list was
 * invalidated. The Model page does NOT use this — it polls via the
 * lighter LoadJobStatesAction (light Query + targeted full-row fetch
 * for new IDs).
 */
export function RefreshAction(session: Session) {
    return async (dispatch: AppDispatch) => {
        dispatch(setJobs({ jobs: [] }));
        dispatch(setJobIndex({}));

        const payload = JSON.stringify({ "table": "jobs" });

        let response: { status: number; data: any };
        try {
            response = await dispatch(CallLambda(session, "tableGrabber", payload));
        } catch {
            return;
        }

        if (response.status !== 200 || !Array.isArray(response.data?.values)) {
            return;
        }

        const jobs = response.data.values.map((job: any) => new Job(
            job.job_id,
            job.model_id,
            job.cust_id,
            job.user_id,
            job.alias,
            job.description,
            job.job_name,
            job.result_name,
            job.task_id,
            job.job_status,
            new Date(job.start_time),
            new Date(job.end_time),
            new Date(job.schedule_time),
            job.schedule_type,
        ));

        dispatch(setJobs({ jobs }));
    };
}
